import React from "react";
import { observer } from "mobx-react-lite";
import { store } from "./store";
import { TourPlayer } from "./components/tour/tour-player/TourPlayer";
import { ShadowDomContainer } from "./components/ShadowDomContainer";
import { PreviewMode } from "./components/preview/PreviewMode";

import "./styles.module.css";
import "./default-theme.css";
import "./custom-themes.css";
import { DebuggerV2 } from "./components/debugger/Debugger.v2";
import { ChecklistCardWrapper } from "./components/checklist/ChecklistCard";

export const App = observer(function App() {
  return (
    <>
      <React.Fragment>
        {store.currentChecklistManager &&
          (!store.currentTour || store.tourLifecycleManager.isChecklistVisibleFromAvatar) && (
            <ChecklistCardWrapper
              checklist={store.currentChecklistManager.checklist}
              userStateStorage={store.storage.userState}
              guideRegistry={store.guideRegistry}
              isMinimized={store.currentChecklistManager.isMinimized}
              onMinimize={() => store.tourLifecycleManager.onChecklistMinimizeClicked()}
              onExpand={() => store.tourLifecycleManager.expandCurrentChecklist()}
              onDismiss={() => store.tourLifecycleManager.dismissCurrentChecklist()}
              onTourStartClicked={(guideId) => {
                store.tourLifecycleManager.onTourStartClickedFromChecklist(guideId);
              }}
            />
          )}

        {store.currentTour && !store.tourLifecycleManager.isChecklistVisibleFromAvatar && (
          <TourPlayer
            tourPlaybackManager={store.currentTour}
            isPartOfChecklist={!!store.currentChecklistManager}
            onChecklistButtonClicked={() => store.tourLifecycleManager.showChecklistFromAvatar()}
          />
        )}
      </React.Fragment>

      {store.isDebugVisible && (
        <ShadowDomContainer>
          <DebuggerV2 manager={store.debuggerManager} />
        </ShadowDomContainer>
      )}

      {/* Preview Mode Banner */}
      {store.isPreview && (
        <ShadowDomContainer>
          <PreviewMode />
        </ShadowDomContainer>
      )}
    </>
  );
});
